export const base_inquiries = [{
					type: 1,
					title: 'شاهکار',
					desc: 'استعلام مطابقت مالکیت خط و کد ملی',
					icon: (items) => items?.some(x => x.parsedResult?.isMatch) ? 'mdi-check' : 'mdi-history',
					active: true,
					badgeColor: (items) => items?.some(x => x.parsedResult?.isMatch) ? 'green' : 'grey lighten-4',
					iconColor: (items) => items?.some(x => x.parsedResult?.isMatch) ? 'white' : 'grey darken-1',
					price: 0
				}, {
					type: 2,
					title: 'شاهکار تکمیلی',
					desc: 'استعلام مطابقت مالکیت خط و کد ملی و تاریخ تولد و شماره شبا',
					icon: (items) => items?.some(x => x.parsedResult?.isMatch) ? 'mdi-check' : 'mdi-history',
					active: true,
					badgeColor: (items) => items?.some(x => x.parsedResult?.isMatch) ? 'green' : 'grey lighten-4',
					iconColor: (items) => items?.some(x => x.parsedResult?.isMatch) ? 'white' : 'grey darken-1',
					price: 0
				}, {
					type: 3,
					title: 'استعلام ثنا',
					desc: 'استعلام وضعیت داشتن یا نداشتن شماره ثنا',
					icon: (items) => items?.some(x => x.parsedResult?.hasSana) ? 'mdi-check' : 'mdi-history',
					active: true,
					badgeColor: (items) => items?.some(x => x.parsedResult?.hasSana) ? 'green' : 'grey lighten-4',
					iconColor: (items) => items?.some(x => x.parsedResult?.hasSana) ? 'white' : 'grey darken-1',
					price: 0
				}, {
					type: 4,
					title: 'استعلام چک برگشتی',
					desc: 'استعلام تعداد چک برگشتی',
					icon: (items) => !items?.length ? 'mdi-history' : items?.some(x => x.parsedResult?.count > 0) ? 'mdi-close' : 'mdi-check',
					active: true,
					badgeColor: (items) => !items?.length ? 'grey lighten-4' : items?.some(x => x.parsedResult?.count > 0) ? 'red' : 'green',
					iconColor: (items) => !items?.length ? 'grey darken-1' : items?.some(x => x.parsedResult?.count > 0) ? 'white' : 'white',
					price: 0
				}, {
					type: 5,
					title: 'مشخصات هویتی',
					desc: 'استعلام مشخصات هویتی بر اساس کد ملی',
					icon: (items) => items?.length ? 'mdi-check' : 'mdi-history',
					active: true,
					badgeColor: (items) => items?.length ? 'green' : 'grey lighten-4',
					iconColor: (items) => items?.length ? 'white' : 'grey darken-1',
					price: 0
				}, {
					type: 6,
					title: 'کدپستی و آدرس',
					desc: 'استعلام آدرس بر اساس کدپستی از اداره پست',
					icon: (items) => items?.length ? 'mdi-check' : 'mdi-history',
					active: true,
					badgeColor: (items) => items?.length ? 'green' : 'grey lighten-4',
					iconColor: (items) => items?.length ? 'white' : 'grey darken-1',
					price: 0
				}, {
					type: 7,
					title: 'پلاک های فعال خودرو',
					desc: 'استعلام پلاک های فعال شخص بر اساس کدملی و شماره موبایل',
					icon: (items) => items?.some(x => x.parsedResult?.length) ? 'mdi-check' : 'mdi-history',
					active: true,
					badgeColor: (items) => items?.some(x => x.parsedResult?.length) ? 'green' : 'grey lighten-4',
					iconColor: (items) => items?.some(x => x.parsedResult?.length) ? 'white' : 'grey darken-1',
					price: 0
				}]
